import { createSelector } from '@reduxjs/toolkit';

import { svgStringToDataUrlEncoded } from 'utils/SvgUtils';

import { getCurrentGroup, getFirstGroup } from './basic';

const getAllTags = (state: IAppState) => {
  return state.groups.groupTagLabels;
};

const getTagsForGroup = (state: IAppState, gid?: string) => {
  let groupId = gid;
  if (!gid) {
    groupId = state.groups.selectedGid;
  }
  const allTags = getAllTags(state);
  const tags = allTags.find((groupTags) => groupTags.gid === groupId)?.tags || [];
  return tags;
};

const getTagSVGs = (state: IAppState) => {
  return state.groups.groupTagSvgs;
};

const getCurrentTagsByGroup = createSelector(
  [getCurrentGroup, getFirstGroup, getAllTags, getTagSVGs],
  (group, firstGroup, allTags, svgs) => {
    let tags: ITag[] = [];
    const orgGid = group?.gid !== 'all' ? group?.parentGid : firstGroup?.parentGid;
    if (orgGid) {
      tags = allTags.find((groupTags) => groupTags.gid === orgGid)?.tags || [];
    }
    const tagsWithSvgs = svgs.map((svg) => {
      const tag = tags.find((tag) => tag.tagId === svg.tagId) || { tagId: svg.tagId, tagLabel: '' };
      return {
        ...tag,
        tagSvg: svgStringToDataUrlEncoded(svg.tagSvg || '')
      };
    });
    return tagsWithSvgs || [];
  }
);

export { getAllTags, getTagsForGroup, getTagSVGs, getCurrentTagsByGroup };
